import { render, staticRenderFns } from "./UserRowSimple.vue?vue&type=template&id=38d3ea74&scoped=true&"
import script from "./UserRowSimple.vue?vue&type=script&lang=js&"
export * from "./UserRowSimple.vue?vue&type=script&lang=js&"
import style0 from "./UserRowSimple.vue?vue&type=style&index=0&id=38d3ea74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3ea74",
  null
  
)

export default component.exports